import { MAGIC_SEARCH_MIN_TERM_LENGTH } from '../constants';

const DIGITS_RE = /^\d+$/;

export const getSearchTerm = (value: string): string => {
  const term = value.trim();
  if (DIGITS_RE.test(term)) return term;
  return term.length >= MAGIC_SEARCH_MIN_TERM_LENGTH ? term : '';
};
